<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block PropertyConditionPopup">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="Select Property">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="categories" formControlName="category" optionLabel="name"
            optionValue="value" placeholder="Category"></p-dropdown>
            <label for="Category">Category</label>
            @for (validation of validationMessages.category; track validation) {
              <span>
                @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="rooms" formControlName="room" optionLabel="name"
            optionValue="value" placeholder="Room"></p-dropdown>
            <label for="Room">Room</label>
            @for (validation of validationMessages.room; track validation) {
              <span>
                @if (form1.get('room').hasError(validation.type) && (form1.get('room').dirty || form1.get('room').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="urgencies" formControlName="urgency" optionLabel="name"
            optionValue="value" placeholder="Urgency"></p-dropdown>
            <label for="Urgency">Urgency</label>
            @for (validation of validationMessages.urgency; track validation) {
              <span>
                @if (form1.get('urgency').hasError(validation.type) && (form1.get('urgency').dirty || form1.get('urgency').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="reasons" formControlName="reason" optionLabel="name"
            optionValue="value" placeholder="Reason"></p-dropdown>
            <label for="Reason">Reason</label>
            @for (validation of validationMessages.reason; track validation) {
              <span>
                @if (form1.get('reason').hasError(validation.type) && (form1.get('reason').dirty || form1.get('reason').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="outcomes" formControlName="outcome" optionLabel="name"
            optionValue="value" placeholder="Outcome"></p-dropdown>
            <label for="Outcome">Outcome</label>
            @for (validation of validationMessages.outcome; track validation) {
              <span>
                @if (form1.get('outcome').hasError(validation.type) && (form1.get('outcome').dirty || form1.get('outcome').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="costEst" id="costEst" type="number" pInputText>
            <label for="costEst">Cost Est</label>
            @for (validation of validationMessages.costEst; track validation) {
              <span>
                @if (form1.get('costEst').hasError(validation.type) && (form1.get('costEst').dirty || form1.get('costEst').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (users != undefined && users.length > 0) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="users" formControlName="enteredByUserId" optionLabel="firstName" optionValue="userId"
                [filter]="true" filterBy="firstName" [showClear]="false" placeholder="Select userId">
              </p-dropdown>
              <label for="enteredByUserId">Entered By</label>
              @for (validation of validationMessages.enteredByUserId; track validation) {
                <span>
                  @if (form1.get('enteredByUserId').hasError(validation.type) && (form1.get('enteredByUserId').dirty || form1.get('enteredByUserId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="visibilities" formControlName="visibility" optionLabel="name"
            optionValue="value" placeholder="Visibility"></p-dropdown>
            <label for="Visibility">Visibility</label>
            @for (validation of validationMessages.visibility; track validation) {
              <span>
                @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="maintenanceEventId" id="maintenanceEventId" type="text" pInputText>
            <label for="maintenanceEventId">Breezway TaskId</label>
            @for (validation of validationMessages.maintenanceEventId; track validation) {
              <span>
                @if (form1.get('maintenanceEventId').hasError(validation.type) && (form1.get('maintenanceEventId').dirty || form1.get('maintenanceEventId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (propertyConditionId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete PropertyCondition</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!propertyConditionId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add PropertyCondition</button>
              }

              @if (propertyConditionId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update PropertyCondition</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>